import React, {Component} from 'react'
import Links from "../../../Route";
import Applications from "./Applications";
import HttpRequest from "../../../HttpRequest";
import Dashboard, {DashboardService} from "./Dashboard";
import {Tools} from "../../../Tools";
import Members from "./Members";
import Components from "../../../components";
import MembersAccounts from "./MembersAccounts";
import Contributions from "../MemberProfile/Contributions";
import Tabs from "../../../components/Tabs";
import MemberProfile from "../MemberProfile";
import ContributionsCreate from "./ContributionsCreate";
import ContributionsSave from "./ContributionsSave";
import {TEMPLATE_PAGE_IN_CONSTRUCTION} from "../../index";
import Reports from "./Reports";
import Route from "../../../Route";
import AuthenticationAPI from "../../../services/AuthenticationAPI";

const
    menuKey = {
        dashboard: "dashboard",
        members: "members",
        applications: "applications",
        member_account: "member_account",
        events: "events",
        manage_contributions: "manage_contributions",
        reports: "reports",
    },
    defaultMenuKey = menuKey.dashboard,
    menu = [
        {
            key: menuKey.dashboard,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Tableau de bord",
            handleClick: null,
            attributes: {
                "data-key": menuKey.dashboard
            },
            roles: []
        },
        {
            key: menuKey.applications,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Demandes en attente",
            handleClick: null,
            attributes: {
                "data-key": menuKey.applications
            },
            roles: [AuthenticationAPI.roles.president, AuthenticationAPI.roles.general_manager]
        },
        {
            key: menuKey.members,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Membres validés",
            handleClick: null,
            attributes: {
                "data-key": menuKey.members
            },
            roles: [AuthenticationAPI.roles.president, AuthenticationAPI.roles.general_manager]
        },
        {
            key: menuKey.member_account,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Compte des membres",
            handleClick: null,
            attributes: {
                "data-key": menuKey.member_account
            },
            roles: [AuthenticationAPI.roles.president, AuthenticationAPI.roles.general_manager]
        },
        {
            key: menuKey.events,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Gestion des évènements",
            handleClick: null,
            attributes: {
                "data-key": menuKey.events
            },
            roles: [AuthenticationAPI.roles.president, AuthenticationAPI.roles.general_manager]
        },
        {
            key: menuKey.manage_contributions,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Gestion des contributions",
            handleClick: null,
            attributes: {
                "data-key": menuKey.manage_contributions
            },
            roles: [AuthenticationAPI.roles.president, AuthenticationAPI.roles.accounting_manager]
        },
        {
            key: menuKey.reports,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Reporting",
            handleClick: null,
            attributes: {
                "data-key": menuKey.reports
            },
        },
    ]
;

class Administration extends Component{

    constructor(props) {
        super(props);
        this.httpClient = new HttpRequest();
        this.state = {
            server: {},
            activeMenu: defaultMenuKey,
            hasRequestInProgress: false,
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            dashboard: null,
        };
        this.handleMenuTopClick = this.handleMenuTopClick.bind(this);
        this.handlerDashboardChange = this.handlerDashboardChange.bind(this);
    }


    handleMenuTopClick(event){
        const activeMenu = event.target.getAttribute("data-key");
        if(this.state.activeMenu !== activeMenu){
            this.setState({activeMenu: activeMenu, hasRequestInProgress: false});
        }
    }

    handlerDashboardChange(dashboard){
        if(dashboard){
            this.setState({dashboard: dashboard});
        }
    }

    isAuthorized(){
        for (let i = 0; i++; menu){

        }
    }

    /**
     *
     * @return {JSX.Element}
     */
    render() {
        let menuContent = "";
        if(this.state.activeMenu){
            switch (this.state.activeMenu){
                case menuKey.applications:
                    menuContent = <Applications data={{dashboard: this.state.dashboard}} onDashboardChange={this.handlerDashboardChange} />;
                    break;
                case menuKey.member_account:
                    menuContent = <MembersAccounts data={{dashboard: this.state.dashboard}} onDashboardChange={this.handlerDashboardChange} />;
                    break;
                case menuKey.members:
                    menuContent = <Members />;
                    break;
                case menuKey.reports:
                    menuContent = <Reports url={Route.APIMembersReports} />;
                    break;
                case menuKey.dashboard:
                    menuContent = <Dashboard data={{dashboard: this.state.dashboard}} onDashboardChange={this.handlerDashboardChange} />;
                    break;
                case menuKey.manage_contributions:
                    let tabs = [];

                    if(AuthenticationAPI.isAccountingManagerUser()){
                        tabs = [
                            {
                                type: "button",
                                className: "btn btn-tab ",
                                label: "Créer une cotisation",
                                attributes: {
                                    "data-key": Contributions.Views.create_contribution.id
                                },
                                handleClick: null,
                                component: <ContributionsCreate view={Contributions.Views.create_contribution} key={Contributions.Views.create_contribution} />
                            },
                            {
                                type: "button",
                                className: "btn btn-tab",
                                label: "Enrégistrer une cotisation",
                                attributes: {
                                    "data-key": Contributions.Views.save_contribution.id
                                },
                                handleClick: null,
                                component: <ContributionsSave view={Contributions.Views.save_contribution} key={Contributions.Views.save_contribution} />
                            }
                        ];
                    }

                    tabs = MemberProfile.getTabsByMenuKey(MemberProfile.menuKey.contribution_repository).concat(tabs);
                    menuContent = <Tabs
                        key={menuKey.manage_contributions}
                        defaultTabSelected={tabs[0].attributes["data-key"]}
                        tabs={tabs} />;
                    break;
                default:
                    menuContent = TEMPLATE_PAGE_IN_CONSTRUCTION;
                    break;
            }
        }

        let newMenu = [];
        if(!Tools.IsEmpty(this.state.dashboard)){
            newMenu = Tools.Clone(menu).map((item) => {
                if(item.key === menuKey.applications && this.state.dashboard.applicationsCount){
                    item.label = item.label + " (" + this.state.dashboard.applicationsCount + ")";
                }
                else if(item.key === menuKey.members && this.state.dashboard.membersValidCount){
                    item.label = item.label + " (" + this.state.dashboard.membersValidCount + ")";
                }
                return {...item}
            });

            if(!AuthenticationAPI.isAdminUser()){
                const currentRole = AuthenticationAPI.userRole();
                newMenu = newMenu.filter((item) => {
                    // if role defined or current the mapped is match
                    return (!item.hasOwnProperty("roles") || item.roles === null || item.roles.length === 0) || item.roles.includes(currentRole);
                });
            }
        }

        return (
            <>
                <div className="inner-head bg-animate">
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-md-8 col-md-offset-2">
                                <h3>{Links.Administration.label}</h3>
                                {
                                    AuthenticationAPI.roleLabels[AuthenticationAPI.userRole()] ?
                                        <h6 className="text-white">
                                            Login : {AuthenticationAPI.getCurrentUser().email}
                                            <br/>
                                            Rôle d'accès : {AuthenticationAPI.roleLabels[AuthenticationAPI.userRole()]}
                                        </h6>
                                        : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>


                <div className="inner-page">
                    <div className="container-fluid">
                        <div className="row admin-font-size">
                            <div className="col-md-3">
                                <aside>
                                    <div className="aside-navbar">
                                        <Components.Specifics.AsideMenu handleClick={this.handleMenuTopClick} data={{
                                            menu: newMenu,
                                            activeMenu: this.state.activeMenu
                                        }} />
                                    </div>
                                </aside>
                            </div>

                            <div className="col-md-9">
                                {menuContent}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    componentDidMount() {
        if(!AuthenticationAPI.hasAdminSpaceAuthorization()){
            window.location = Route.MemberProfile.link;
            return;
        }
        this.loadDashboard();
    }

    loadDashboard() {
        const _self = this;
        DashboardService().then(function (response){
            _self.server = response.server;
            _self.setState(response.data);
        }).catch(function (response){
            _self.server = response.server;
            _self.setState(response.data);
        });
    }
}

export default Administration;